package com.dotdrives.web

import com.dotdrives.controller.DonorController
import com.dotdrives.model.*
import com.dotdrives.repository.SupabaseDonorRepository
import com.dotdrives.web.pages.donor.DonorPortalPage
import com.dotdrives.web.ui.useFlowState
import kotlinx.browser.window
import kotlinx.coroutines.*
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import react.*

external interface DonorCompositionProps : Props {
    var email: String
    var userId: String
    var hasTeam: Boolean
    var onTeam: () -> Unit
    var onSignOut: () -> Unit
}

internal class BrowserDonorOperations(private val userId: String, private val namespace: String = "donor") : DonorOperationStore {
    private val json = Json { explicitNulls = false }

    private fun key(orgId: String) = "dotdrives.$namespace.operation:$userId:$orgId"

    override fun read(orgId: String): DonorRecurringRequest? =
        window.sessionStorage
            .getItem(key(orgId))
            ?.let { json.decodeFromString<DonorRecurringRequest>(it) }
            .also { require(it == null || it.orgId == orgId) { "Saved request unavailable." } }

    override fun save(request: DonorRecurringRequest) {
        window.sessionStorage.setItem(key(request.orgId), json.encodeToString(request))
    }

    override fun clear(orgId: String) {
        window.sessionStorage.removeItem(key(orgId))
    }
}

val DonorComposition =
    FC<DonorCompositionProps> { props ->
        val (scope) = useState { MainScope() }
        val (controller) =
            useState {
                DonorController(
                    SupabaseDonorRepository(),
                    scope,
                    BrowserDonorOperations(props.userId),
                )
            }
        val state = useFlowState(controller.state)
        useEffect(controller) {
            controller.start()
            try {
                awaitCancellation()
            } finally {
                scope.cancel()
            }
        }
        useEffect(state.redirectUrl) {
            state.redirectUrl?.let { url ->
                if (url.startsWith("https://billing.stripe.com/")) {
                    controller.clearRedirect()
                    window.location.assign(url)
                }
            }
        }
        DonorPortalPage {
            this.state = state
            this.controller = controller
            email = props.email
            hasTeam = props.hasTeam
            onTeam = props.onTeam
            onSignOut = props.onSignOut
        }
    }
